var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPreqin = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  fill: "#D6006E"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.7002 4.82812C9.7002 4.37076 10.071 4 10.5283 4C10.9857 4 11.3564 4.37076 11.3564 4.82812L11.3564 9.79687C11.3564 10.2542 10.9857 10.625 10.5283 10.625C10.071 10.625 9.7002 10.2542 9.7002 9.79687L9.7002 4.82812ZM6.87207 6.7207C6.87222 6.26347 7.24293 5.89258 7.7002 5.89258C8.15746 5.89258 8.52817 6.26347 8.52832 6.7207L8.52832 9.79687C8.52832 10.2542 8.15756 10.625 7.7002 10.625C7.24283 10.625 6.87207 10.2542 6.87207 9.79687L6.87207 6.7207ZM4 8.96875C4 8.51145 4.37085 8.14073 4.82812 8.14062C5.28549 8.14062 5.65625 8.51139 5.65625 8.96875L5.65625 9.79687C5.65625 10.2542 5.28549 10.625 4.82812 10.625C4.37085 10.6249 4 10.2542 4 9.79688L4 8.96875Z",
  fill: "white"
})));
export { SvgPreqin as ReactComponent };
export default __webpack_public_path__ + "preqin.304d6428482aea92663c49cfe22fdd34.svg";